export var UploadFileType;
(function (UploadFileType) {
    UploadFileType[UploadFileType["Xlsx"] = 1] = "Xlsx";
    UploadFileType[UploadFileType["Csv"] = 2] = "Csv";
    UploadFileType[UploadFileType["Txt"] = 3] = "Txt";
})(UploadFileType || (UploadFileType = {}));
